module.exports = __webpack_public_path__ + "static/media/btn-podcast-white.024049e8.svg";